







































































































import Breadcrumb from './Breadcrumb.vue'
import NavigateBackButton from './NavigateBackButton.vue'
import TopMenu from './TopMenu.vue'
import useBreadcrumb from '@/composables/useBreadcrumb'
import { defineComponent, ref, onMounted, computed } from '@vue/composition-api'
import { Wormhole } from 'portal-vue'
import { useAuth } from '@/composables/useAuth'
import { useRouter } from '@u3u/vue-hooks'
import { useApp } from '@/composables/useApp'

export default defineComponent({
  name: 'Layout',

  components: {
    Breadcrumb,
    TopMenu,
    NavigateBackButton
  },

  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },

  setup(_, { root }) {
    const collapsed = ref(false)
    const { isLoggedIn, logout } = useAuth()
    const { router, route } = useRouter()

    const { altApps, currentApp } = useApp()
    // eslint-disable-next-line
    const handleAppChange = (app: any) => {
      let href: string
      if (route.value.params.id) {
        href = router.resolve({
          name: 'dashboard',
          params: { ...route.value.params, ...app.routeParams }
        }).href
      } else {
        href = router.resolve({
          name: route.value.name ?? '',
          params: { ...route.value.params, ...app.routeParams }
        }).href
      }
      window.location.replace(href)
    }

    // Temp
    const { showBreadcrumb } = useBreadcrumb()

    onMounted(() => {
      root.$message.config({
        getContainer: () =>
          document.querySelector('.main-layout-header') ||
          // eslint-disable-next-line
          document.querySelector('body')!
      })
    })

    return {
      altApps,
      handleAppChange,
      currentApp,

      isLoggedIn,
      logout: () => {
        logout()
        router.push({ name: 'login' })
      },

      collapsed,

      showSecondaryBar: computed(
        () => Wormhole.hasContentFor('page-header') || showBreadcrumb.value
      )
    }
  }
})
